/**
 * Widths of a store card in the product grid: one column on phones, two from
 * `sm`, three from `lg` (StoreSaleItemCard.scss).
 * @const STORE_CARD_SIZES
 * @since 1.0.0
 */
export const STORE_CARD_SIZES = '(min-width: 992px) 33vw, (min-width: 576px) 50vw, 100vw';
/**
 * Widths of a sales form card: three columns from `md`, full width below
 * (form/components/SaleItemCard.scss).
 * @const FORM_CARD_SIZES
 * @since 1.0.0
 */
export const FORM_CARD_SIZES = '(min-width: 768px) 32vw, 100vw';
/**
 * Product image beside the options of the store (StoreProductBlockHeader.scss):
 * 320px column from `md`, full width below.
 * @const BLOCK_HEADER_SIZES
 * @since 1.0.0
 */
export const BLOCK_HEADER_SIZES = '(min-width: 768px) 320px, 100vw';
/**
 * Logo of the store and sales form headers (at most 175px wide).
 * @const LOGO_SIZES
 * @since 1.0.0
 */
export const LOGO_SIZES = '175px';
/**
 * Main image of the product viewer modal.
 * @const VIEWER_SIZES
 * @since 1.0.0
 */
export const VIEWER_SIZES = '(min-width: 768px) 720px, 100vw';
/**
 * Sources of a large image: the 320px thumbnail and the WebP display version
 * when they exist, the original otherwise. A width of 0 means the version
 * could not be generated.
 * @function imageSources
 * @since 1.0.0
 */
export function imageSources(media, sizes) {
    const candidates = [];
    // The thumbnail alone would be the only candidate, so phones would show
    // 320px on a full-width image: it only joins the display version.
    if (media.thumbnail && media.thumbnailWidth && media.display) {
        candidates.push(`${encodeSrc(media.thumbnail)} ${media.thumbnailWidth}w`);
    }
    if (media.display && media.displayWidth) {
        candidates.push(`${encodeSrc(media.display)} ${media.displayWidth}w`);
    }
    return {
        source: media.url,
        srcSet: candidates.length > 0 ? candidates.join(', ') : undefined,
        sizes: candidates.length > 0 ? sizes : undefined
    };
}
/**
 * Source of a small image (option rows, summary lines, gallery thumbs): the
 * 320px thumbnail, else the display version, else the original. A PDF has an
 * empty thumbnail; a Shopify image has its own URL as thumbnail.
 * @function thumbnailSource
 * @since 1.0.0
 */
export function thumbnailSource(media) {
    if (media.thumbnail) {
        return media.thumbnail;
    }
    if (media.display && media.displayWidth) {
        return media.display;
    }
    return media.url;
}
/**
 * Commas and spaces separate srcset candidates, so they are escaped in URLs.
 * @function encodeSrc
 * @hidden
 */
function encodeSrc(url) {
    return url.replace(/ /g, '%20').replace(/,/g, '%2C');
}
